import { Box } from '@material-ui/core';
import { StandardDialog, Button, ConfirmationButton, SelectField, } from '@roc/ui';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { usePayoffRequestStore } from '@roc/feature-loans';
import { useBaseStore } from '@roc/feature-app-core';


interface IPutOnHoldDialogProps {
  loanId: number;
  payoffId: number;
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(theme => ({
  button: {
    marginRight: '8px'
  },
}));

export const PutOnHoldDialog = observer(({ loanId, payoffId, open, onClose }: IPutOnHoldDialogProps) => {
  const classes = useStyles();
  const { payoffRequestStore } = usePayoffRequestStore();
  const [selectedReason, setselectedReason] = useState<string>('')
  const isOnHold = payoffRequestStore.selectedPayoff?.payoffStatus === 'On Hold';
  const { globalStore } = useBaseStore();

  useEffect(() => {
    if (open) {
      setselectedReason(isOnHold ? payoffRequestStore.selectedPayoff?.onHoldReason : '');
    }

  }, [open])

  useEffect(() => {
    payoffRequestStore.getOnHoldReasons();
  }, [])

  const onSubmit = async () => {
    if (selectedReason != '') {
      await payoffRequestStore.putOnHoldPayoff(loanId, payoffRequestStore.selectedPayoffId, selectedReason, isOnHold)
      await payoffRequestStore.initPayoffInternal(loanId);
      onClose();
    } else {
      globalStore.notificationStore.showErrorNotification({
        message: 'Please select an on hold reason',
      });
    }

  }

  const getContent = () => {
    return (
      <Box display="flex" justifyContent={"center"} flexDirection="column" height="100%" width="100%">
        <SelectField
          disabled={isOnHold}
          label='On Hold Reason:'
          options={payoffRequestStore.onHoldReasons}
          testId={'selectedPayoff'}
          value={selectedReason}
          onChange={(value) => setselectedReason(value)}
          fullWidth
          variant="outlined"
          placeholder='Please select an option'
          standaloneLabel
        />
      </Box>
    )
  }

  return (
    <StandardDialog
      open={open}
      title={isOnHold ? 'Remove On Hold' : 'Put On Hold'}
      maxWidth="sm"
      handleClose={onClose}
      dialogContent={
        getContent()
      }
      dialogActions={(
        <>
          <Box mr={2}>
            <Button
              className={classes.button}
              variant="outlined"
              color="primary"
              onClick={onClose}
              testId="close"
            >
              CLOSE
            </Button>
            <ConfirmationButton
              onClick={onSubmit}
              color="primary"
              variant="contained"
              testId="confirm"
              confirmDialogProps={{
                title: 'Confirmation',
                body:
                  isOnHold ? "Are you sure you want to remove the hold on this payoff?" : "Are you sure you want to place this payoff on hold?",
              }}
            >
              {!isOnHold ? 'SUBMIT' : 'REMOVE ON HOLD'}
            </ConfirmationButton>
          </Box>
        </>
      )}
    />
  );
});